import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useInvitationToken } from "@/hooks/useInvitationToken";
import { Loader2 } from "lucide-react";

const inviteSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute("/invite")({
  validateSearch: inviteSearchSchema,
  component: InvitePage,
});

function InvitePage() {
  const { isProcessing, error } = useInvitationToken();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center space-y-4 text-center">
        {isProcessing ? (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <h1 className="text-2xl font-semibold">Processing invitation...</h1>
            <p className="text-muted-foreground">
              Please wait while we set up your access to the project.
            </p>
          </>
        ) : error ? (
          <>
            <div className="rounded-full bg-destructive/10 p-3">
              <svg
                className="h-8 w-8 text-destructive"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-semibold">Invalid invitation</h1>
            <p className="text-muted-foreground max-w-md">
              This invitation link is invalid or has expired. Please ask your
              team member for a new invitation.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <h1 className="text-2xl font-semibold">Loading...</h1>
          </>
        )}
      </div>
    </div>
  );
}